<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">Dashboard de Coordenação de Cuidado</strong>
    </div>
    <div class="row">
      <div class="col-xs-6 col-md-4">
        <div class="card">
          <div class="card-body">

          <!--  Funil Geral Bar Begins           -->
            <h5 class="text-black">
              <strong>Funil Geral</strong>
            </h5>
            <div class="mb-auto">
                <div
                  :class="$style.chartBarExample">
                    <vue-chartist
                      type="Bar"
                      :data="overlappingBarData"
                      :options="overlappingBarOptions"
                      :responsive-options="overlappingResponsiveOptions"
                    />
                </div>
            </div>
          <!-- Funial Geral Ends -->

          </div>
        </div>
      </div>
      <div class="col-xs-6 col-md-4">
        <div class="card">
          <div class="card-body">

            <!--       Indice Saude Begins     -->
            <h5 class="text-black">
             <strong>Índice Médio de Saúde da Carteira</strong>
            </h5>
                <vue-chartist
                  type="Line"
                  :data="areaData"
                  :options="areaOptions"
                />
            <!--       Indice Saude Ends     -->

          </div>
        </div>
      </div>
      <div class="col-xs-6 col-md-4">
        <div class="card">
          <div class="card-body">

            <!--       Indice Risco Begins     -->
            <h5 class="text-black">
             <strong>Índice Médio de Risco da Carteira</strong>
            </h5>
                <div
                  :class="$style.chartLineExample"
                      >
                  <vue-chartist
                    type="Line"
                    :data="riskData"
                    :options="areaOptions"
                  />
                </div>

            <!--       Indice Risco Ends     -->

          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-6 col-md-4">
        <div class="card">
          <div class="card-body">
            <!--       Indice Cumprindo SLA Begins     -->
            <h5 class="text-black">
             <strong>Cumprindo SLA</strong>
            </h5>
                     <div
                        :class="$style.chartBarExample"
                      >
                        <vue-chartist
                          type="Bar"
                          :data="NPSData"
                          :options="horizontalOptions"
                        />
                      </div>
            <!--       Indice Cumprindo SLA Ends     -->

          </div>
        </div>
      </div>
      <div class="col-xs-6 col-md-4">
        <div class="card">
          <div class="card-body">
            <div align="center">
              <h5 class="text-black">
                <strong>Pronto Socorro Sem Recomendação (%)</strong>
              </h5>
            </div>
              <div align="center">
                <vue-speedometer
                  :value="30"
                  :height="200"
                  :minValue="0"
                  :maxValue="100"
                  needleColor="steelblue"
                  :segmentColors='["#3CB26C", "#FBBC30","#FFAC30", "#ff7b31", "#DE1313"]'
                  :needleTransitionDuration="4000"
                  needleTransition="easeElastic"
                />
              </div>

          </div>
        </div>
      </div>
      <div class="col-xs-6 col-md-4">
        <div class="card">
          <div class="card-body">
            <div align="center">
              <h5 class="text-black">
              <strong>Consulta Especialista sem Recomendação (%)</strong>
              </h5>
            </div>
              <div align="center">
                <vue-speedometer
                  :value="15"
                  :minValue="0"
                  :height="200"
                  :maxValue="100"
                  needleColor="steelblue"
                  :segmentColors='["#3CB26C", "#FBBC30","#FFAC30", "#ff7b31", "#DE1313"]'
                  :needleTransitionDuration="3000"
                  needleTransition="easeElastic"
                />
              </div>

          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="utils__title mb-6">
        <strong class="text-uppercase font-size-16">PACIENTES EM PROGRAMAS ESPECIAIS</strong>
      </div>
    </div>
    <div class="row">
       <div class="col-xl-3" v-for="(chartCard, index) in chartCardData" :key="index">
        <cui-chart-card
          :title="chartCard.title"
          :amount="chartCard.amount"
          :chartData="chartCard.chartData"
        />
       </div>

    </div>

  </div>
</template>
<script>

import VueChartist from 'v-chartist'
import ChartistTooltip from 'chartist-plugin-tooltips-updated'
import VueSpeedometer from 'vue-speedometer'
import CuiChartCard from '@/components/CleanUIComponents/ChartCard'

import data, {
  overlappingBarData,
  areaData,
  riskData,
  supportCasesTableData,
  NPSData,
} from './data.json'

const overlappingBarOptions = {
  seriesBarDistance: 10,
  plugins: [ChartistTooltip({ anchorToPoint: false, appendToBody: true, seriesName: false })],
}

const areaOptions = {
  low: 0,
  showArea: true,
  plugins: [ChartistTooltip({ anchorToPoint: false, appendToBody: true, seriesName: false })],
}

const horizontalOptions = {
  seriesBarDistance: 10,
  reverseData: !0,
  horizontalBars: !0,
  axisY: {
    offset: 70,
  },
  plugins: [ChartistTooltip({ anchorToPoint: false, appendToBody: true, seriesName: false })],
}

const overlappingResponsiveOptions = [
  [
    '',
    {
      seriesBarDistance: 5,
    },
  ],
]

export default {
  components: {
    'vue-speedometer': VueSpeedometer,
    'vue-chartist': VueChartist,
    CuiChartCard,
  },
  data: function () {
    return {
      chartCardData: data.chartCardData,
      overlappingBarData,
      overlappingBarOptions,
      overlappingResponsiveOptions,
      areaOptions,
      areaData,
      riskData,
      NPSData,
      horizontalOptions,
      supportCasesTableData,
    }
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
